import { Integration_Handler_Names_Enum } from '@main/graphql/types.generated';
import { z } from 'zod/v4';

import { IntegrationConfig } from '../../../../../../lib';
import { IamService } from '../../service';

export type NoAdminPrivilegesConfig = typeof NoAdminPrivilegesConfig._.Config;

export const NoAdminPrivilegesConfig = IntegrationConfig.make({
  service: IamService,
  name: Integration_Handler_Names_Enum.NoAdminPrivileges,
  configSchema: z.object({}),
});
